import { render, staticRenderFns } from "./AprovarAtaView.vue?vue&type=template&id=054a1330&scoped=true"
import script from "./AprovarAtaView.vue?vue&type=script&lang=js"
export * from "./AprovarAtaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a1330",
  null
  
)

export default component.exports